import { render } from "./FileManagerTabsView.vue?vue&type=template&id=8114908a"
import script from "./FileManagerTabsView.vue?vue&type=script&lang=js"
export * from "./FileManagerTabsView.vue?vue&type=script&lang=js"

import "./FileManagerTabsView.vue?vue&type=style&index=0&id=8114908a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__